import { readable } from "svelte/store";
import Navaid from "navaid";

export const router = readable(new Navaid("/welcome"));
